import { put, call, takeEvery } from 'redux-saga/effects';
import * as apis from '../../network/apis/lookUps';
import * as types from './types';
import * as actions from './actions';
import { showErrorMsg, showSuccessMsg } from '../../utils/Helpers';

function* getCurranciesListSaga({ payload }) {
  try {
    const response = yield call(apis.getCurranciesList, payload);
    yield put(actions.getCurranciesResponse(response.data.currencies));
  } catch (error) {
    yield showErrorMsg(error.response?.data?.message);
  }
}

function* getSpecialtiesLookupSaga({ payload }) {
  try {
    const response = yield call(apis.getSpecialtiesListLookup, payload);
    yield put(actions.getSpecialtiesLookupResponse(response.data.branch_specialties));
  } catch (error) {
    yield showErrorMsg(error.response?.data?.message);
  }
}


function* getBranchesLookupSaga({ payload }) {
  try {
    const response = yield call(apis.getBranchesList, payload);
    yield put(actions.getBranchesLookupResponse(response.data.branches));
  } catch (error) {
    yield showErrorMsg(error.response?.data?.message);
  }
}

function* getProvidersLookupSaga({ payload }) {
  try {
    const response = yield call(apis.getProvidersList, payload);
    yield put(actions.getProvidersLookupResponse(response.data.service_providers));
  } catch (error) {
    yield showErrorMsg(error.response?.data?.message);
  }
}

function* getServicesListLookUpSaga({ payload }) {
  try {
    const response = yield call(apis.getServicesListLookUp, payload);
    yield put(actions.getServicesLookUpResponse(response?.data?.services));
  } catch (error) {
    yield showErrorMsg(error.response?.data?.message);
  }
}

export default function* LookUpsSagas() {
  yield takeEvery(types.GET_CURRANCIES_REQUEST, getCurranciesListSaga);
  yield takeEvery(types.GET_SPECIALITIES_LOOKUP_REQUEST, getSpecialtiesLookupSaga);
  yield takeEvery(types.GET_BRANCHES_LOOKUP_REQUEST, getBranchesLookupSaga);
  yield takeEvery(types.GET_PROVIDERS_LOOKUP_REQUEST, getProvidersLookupSaga);
  yield takeEvery(types.GET_SERVICES_LOOKUP_REQUEST, getServicesListLookUpSaga);
}
